/**
 * Product card truncation (ISS:04-019)
 * Adds `is-truncated` class for elements that overflow their max height.
 */

import { productCardForm } from "./product-card-form";

class ProductCardTruncationUtils {
    private static getTooltipText(element: HTMLElement): string {
        return (element.textContent || "").replace(/\s+/g, " ").trim();
    }

    /**
     * Mark elements as truncated (adds/removes `is-truncated`).
     *
     * This is typically called on initial render and on window resize.
     * Overflow depends on the element's rendered size (responsive wrapping),
     * so we must re-evaluate after layout changes.
     */
    public static mark(root: ParentNode): void {
        const elements = productCardForm.getTruncationTargets(root);

        elements.forEach((element) => {
            element.classList.remove("is-truncated");

            const isTruncated =
                element.scrollHeight > element.clientHeight + 1 || element.scrollWidth > element.clientWidth + 1;
            if (isTruncated) {
                element.classList.add("is-truncated");
                const tooltipText = this.getTooltipText(element);
                if (tooltipText !== "") {
                    element.setAttribute("title", tooltipText);
                }
                return;
            }

            element.removeAttribute("title");
        });
    }
}

export { ProductCardTruncationUtils };
